import React from "react";
import "./styles.css";
import { db } from "../../utils/firebase";

function Blog() {
  return (
    <div className="blogContainer">
      {/* <h1>Blog</h1> */}
      <p>NOTHING HERE YET...</p>
    </div>
  );
}

export default Blog;
